const defaultState = null;

export default (state = defaultState, action) => {
  if (action.type === 'SENTRY_EVENT_ID') {
    return action.eventId;
  }
  return state;
};
